/**
 * Lifecycle-Zustände und Typen für Sonnen.
 * Jede Sonne durchläuft: Alive → Imploding → Exploding/Collapsing → Dead/BlackHole.
 * Lebensdauer: 3–5 Monate Echtzeit.
 */

export const SunState = {
  Alive: 0,
  Imploding: 1,
  Exploding: 2,
  CollapsingToBlackHole: 3,
  BlackHole: 4,
  Dead: 5,
} as const;

export type SunState = (typeof SunState)[keyof typeof SunState];

/** Bestimmt, was beim Tod einer Sonne passiert. */
export type SunFate = 'explode' | 'black_hole';

/** Lifecycle-Daten pro Sonne. Mutable intern, readonly für Konsumenten. */
export interface SunLifecycleEntry {
  entityId: string;
  state: SunState;
  fate: SunFate;
  /** 0.0 (neugeboren) bis 1.0 (Zerstörungszeit erreicht). */
  age: number;
  /** Verbleibende Sekunden bis zur Zerstörung. Negativ = überschritten. */
  remainingSec: number;
  /** Zerstörungszeitpunkt in ms (Date.now()-Basis). */
  destructionTime: number;
  /** Skalierungsfaktor für Rendering. 1.0 = normal. */
  scaleMul: number;
}

/** Registrierungsdaten für eine Sonne. */
export interface SunRegistration {
  readonly entityId: string;
  /** Zeitstempel der Welterstellung in ms. */
  readonly createdAt: number;
  /** Zeitstempel der Zerstörung in ms. */
  readonly destructionTime: number;
  readonly fate: SunFate;
}
